import React from 'react';
import { Image } from '../../wag-react/core-components/image';
import { Box } from '../Box';
import { Flex } from '../Flex';
import { Typography } from '../Typography';

// TODO - Use an svg to be more optimized
import notFoundErrorImage from '../../assets/images/404-error.png';
export type Props = {
  message?: string;
  statusCode: number;
};
export const Error = ({
  message,
  statusCode
}: Props) => <>
    <Flex flexDirection="column" alignItems="center" px="50px" textAlign="center" data-sentry-element="Flex" data-sentry-source-file="Error.tsx">
      <Typography variant="h1" data-sentry-element="Typography" data-sentry-source-file="Error.tsx">
        Ruh-roh!
      </Typography>
      <Typography m={0} data-sentry-element="Typography" data-sentry-source-file="Error.tsx">
        {message}
      </Typography>
      <Typography data-sentry-element="Typography" data-sentry-source-file="Error.tsx">
        {`Error Code: ${statusCode}`}
      </Typography>
      <hr style={{
      height: '1px',
      width: '100%',
      border: 'none',
      backgroundColor: '#ddd'
    }} />
    </Flex>

    <Flex px="50px" flexDirection={['column-reverse', 'row']} justifyContent="center" alignItems={['center', 'start']} data-sentry-element="Flex" data-sentry-source-file="Error.tsx">
      <Box data-sentry-element="Box" data-sentry-source-file="Error.tsx">
        <Typography variant="h3" data-sentry-element="Typography" data-sentry-source-file="Error.tsx">
          Q: What do you call a dog with a fever?
        </Typography>
        <Typography data-sentry-element="Typography" data-sentry-source-file="Error.tsx">
          A: A hot dog.
        </Typography>
      </Box>
      <Box width={[1, 1 / 2]} data-sentry-element="Box" data-sentry-source-file="Error.tsx">
        <Image src={notFoundErrorImage} alt="not-found" width={1} data-sentry-element="Image" data-sentry-source-file="Error.tsx" />
      </Box>
    </Flex>
  </>;